export const costs = [
  'You learned the boiler room from scattered manuals, old procedures and "that\'s how we always did it"',
  "Trips, water hammer, failed traps and exchangers that lose performance show up and you don't fully understand what the system is telling you",
  'Steam tables, water treatment, safety devices and heat exchanger performance still feel confusing',
  'Mistakes around boilers and steam cost production, energy, money and safety',
];
